module.exports = __webpack_public_path__ + "img/badge_rimbosi_spesa.01403287.jpg";